import React from "react";
import Row2 from "../Row2";
import Column2 from "../Column2";
import Row4 from "../Row4";
// import "./AdmitCard.css";

function AdmitCard(props) {
  const {
    image5,
    title,
    admitCardNo,
    number,
    place1,
    address,
    examinationCenter,
    centerName,
    place2,
    centerAddress,
    unacademyPlotNo,
    instructionsToTheCandidate,
    text1,
    text2,
    text3,
    row21Props,
    row22Props,
    column21Props,
    column22Props,
    column23Props,
    row41Props,
    row42Props,
    row43Props,
  } = props;

  

  return (
    <div className="container-center-horizontal">
      <div className="admit-card screen">
        <div className="overlap-group1">
          <img className="frame-1" src="/img/frame-1.svg" alt="Frame 1" />
          <div className="border">
            <div className="main-data">
              <div className="overlap-group">
                <header className="header">
                  <div className="frame-2">
                    <img className="image-5" src={image5} alt="image 5" />
                  </div>
                  <div className="frame-1-1">
                    <h1 className="title">{title}</h1>
                  </div>
                </header>
                <div className="group">
                  <div className="row-1">
                    <div className="frame-2-1">
                      <div className="column-1-1">
                        <div className="admit-card-no avertastd-bold-limed-spruce-40px">{admitCardNo}</div>
                      </div>
                      <div className="column-2">
                        <div className="number avertastd-bold-limed-spruce-40px">{number}</div>
                      </div>
                    </div>
                    <div className="frame-3">
                      <div className="column-1-2">
                        <div className="place avertastd-bold-limed-spruce-40px">{place1}</div>
                      </div>
                      <div className="column-2">
                        <div className="address avertastd-bold-limed-spruce-40px">{address}</div>
                      </div>
                    </div>
                  </div>
                  <Row2
                    nameOfTheCandidate={row21Props.nameOfTheCandidate}
                    rajendraKumar={row21Props.rajendraKumar}
                    surname={row21Props.surname}
                    saturday={row21Props.saturday}
                  />
                  <Row2
                    nameOfTheCandidate={row22Props.nameOfTheCandidate}
                    rajendraKumar={row22Props.rajendraKumar}
                    surname={row22Props.surname}
                    saturday={row22Props.saturday}
                  />
                  <div className="row">
                    <div className="frame-2-2 avertastd-bold-limed-spruce-40px">
                      <div className="column-1-3">
                        <div className="examination-center">{examinationCenter}</div>
                      </div>
                      <div className="column-3">
                        <div className="center">{centerName}</div>
                        <div className="place-1">{place2}</div>
                      </div>
                      <div className="column-3">
                        <div className="center">{centerAddress}</div>
                        <p className="place-1">{unacademyPlotNo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="instruction-to-the-candidate">
              <div className="column-1-4">
                <div className="instructions-to-the-candidate">{instructionsToTheCandidate}</div>
              </div>
              <div className="frame-1-2">
                <div className="row">
                  <div className="column-12">
                    <div className="text-1 poppins-medium-limed-spruce-30px">{text1}</div>
                  </div>
                  <Column2>{column21Props.children}</Column2>
                </div>
                <div className="row">
                  <div className="column-12">
                    <div className="text-2 poppins-medium-limed-spruce-30px">{text2}</div>
                  </div>
                  <Column2>{column22Props.children}</Column2>
                </div>
                <div className="row">
                  <div className="column-12">
                    <div className="text-3 poppins-medium-limed-spruce-30px">{text3}</div>
                  </div>
                  <Column2>{column23Props.children}</Column2>
                </div>
                <Row4 text4={row41Props.text4} column2Props={row41Props.column2Props} />
                <Row4 text4={row42Props.text4} column2Props={row42Props.column2Props} />
                <Row4 text4={row43Props.text4} column2Props={row43Props.column2Props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdmitCard;
